import { Component, OnInit } from '@angular/core';
import { AppComponent } from '@app/app.component';
@Component({
  selector: 'app-pdf',
  templateUrl: './pdf.component.html'
})
export class PdfComponent implements OnInit {

  constructor(
    private appComponent: AppComponent,

  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.appComponent.application.hasFooter = false;
    this.appComponent.showHelpCenter = false;
    this.appComponent.innerWidth = 100;
    // window['embedded_svc'].settings.displayHelpButton = false;
  }
}




// http://localhost:4200/pdftemplate?token=4ffab796